import {Component, Input, OnInit} from '@angular/core';
import {EngineTabTypes} from '../../models/engine-tab-types.enum';
import {HolidaySearchParams} from '../../../booking-flow/holiday/holiday-search-page/interfaces/holiday-search-params';
import {ICruiseSearchParams} from "../../../booking-flow/cruise/cruise-search-page/interfaces/icruise-search-params";

@Component({
  selector: 'app-engine-body',
  templateUrl: './engine-body.component.html',
  styleUrls: ['./engine-body.component.scss']
})
export class EngineBodyComponent implements OnInit {

  @Input() selectedTab: EngineTabTypes;
  @Input() holidaySearchParams: HolidaySearchParams;
  @Input() cruiseSearchParams: ICruiseSearchParams;

  engineTabTypes = EngineTabTypes;

  constructor() { }

  ngOnInit(): void {
  }

}
